import { Component, Input, OnInit, OnChanges, AfterContentChecked, SimpleChanges, ViewChild } from '@angular/core';
import {  FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Observable, map, startWith, Subject } from 'rxjs';
import { DropDown } from 'src/app/shared/models/app-models/DropDown.model';
import { DropDownOptions } from 'src/app/shared/models/app-models/DropDownOption.model';
import { MatAutocomplete } from '@angular/material/autocomplete';
@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
})
export class DropdownComponent implements OnInit, OnChanges, AfterContentChecked {
  @Input() dropDown!: DropDown;
  @Input() selectedOption: DropDownOptions = { id: 'test', value: 'test' };
  @Input() Options: DropDownOptions[] = [];
  @Input() control!: FormControl;
  @Input() haveAutoComplete: boolean = true;
  @Input() isMandatory: boolean = false;
  @Input() isDisabled: boolean = false;
  // used to differentiate cascading dropdowns that requires filtering between two dropdowns.
  @Input() type: string = 'normal';
  @Input() isAutoSet: boolean = false;
  @ViewChild("autoRo") autocomplete!: MatAutocomplete;
  destroy$: Subject<boolean> = new Subject<boolean>();
  filteredOptions!: Observable<DropDownOptions[]>;
  //hide the delete button if dropdown is disabled
  disabled: boolean = false;
  isOptionSelected: boolean = false
  optionSelected!: DropDownOptions;
  /* Notes: 
  Some dropdowns are saved with its id, some with its value.
  Dropdowns saved in id: MatGroup (Code), MatSubGroup (Code), UOM. The others have their values saved.
  isCOTS is saved in boolean but has numerical id and string value. 
  */
  ngOnInit(): void {
    
    this.filteredOptions = this.control.valueChanges.pipe(
      startWith(''),
      map((option) => {
        try {
          if (this.isOptionSelected) {
            this.isOptionSelected = false
            return this.Options.slice()
          }
          const value = typeof option === 'string' ? option : option?.value;
          if (this.haveAutoComplete) {
            return value ? this._filter(value as string) : this.Options?.slice();
          }
          return value ? value : this.Options?.slice();
        } catch (err) {
          console.log('the control: ', option); // one of the exceptions caused is from the currency dropdown.
          console.log('error due to : ', err);
          return option;
        }
      })
    );
  }
  ngOnChanges(changes: SimpleChanges): void {
    // console.log("current", changes["Options"])

    if (changes["Options"]) {
      // dont ask me how it works
      if (this.type == 'Cascading') {
        if (changes["Options"].firstChange && changes["isAutoSet"]) return;
        console.log("called here")
        this.control.setValue('');
      }

    }
    if (changes["isAutoSet"]) {
      if (this.isAutoSet) {
        console.log("for selected", this.Options, this.control.value)
        this.isOptionSelected = true
        this.optionSelected = this.Options.find((o)=>o.id==this.control.value?.id) as DropDownOptions
        if (this.optionSelected?.value && this.optionSelected?.value !== null && this.optionSelected?.value !== 'test' &&
          this.optionSelected?.value !== '')
          this.control.setValue(this.optionSelected)
      }
    }

    //     if (changes["Options"]) {
    //   // dont ask me how it works
   
    //     if (changes["Options"].firstChange) return;
    //     this.control.setValue('');
  

    // }
    
  }

  ngAfterContentChecked(): void {
    this.disabled = this.control.status.trim().toLowerCase() === 'disabled';
  }

  clearField() {
    console.log('clearing field');
    this.control.reset();
  }

  private _filter(currentOption: string): DropDownOptions[] {
    //console.log(this.Options)
    const filterValue = currentOption.toLowerCase();
    return this.Options.filter((option) => {
      if (option.value) {
        return option.value.toLowerCase().includes(filterValue);
      } else {
        return false;
      }
    });
  }

  getOptionValue(option: DropDownOptions) {
    return option && option.value ? option.value : '';
  }

  onOptionSelected(event: MatAutocompleteSelectedEvent) {
    //  set this to true when a user select an option to return the entire option list when triggering the filter function.
    this.isOptionSelected = true
    this.optionSelected = event.option.value
    this.control.setValue(event.option.value)
  }

  onDropdownOpened() {

    // setting offset to to the panel scrolling 
    if (this.optionSelected) {
      const index = this.Options.indexOf(this.optionSelected)
      const optionHeight = 48;
      setTimeout(()=> this.autocomplete.panel.nativeElement.scrollTop = index * optionHeight, 100)
    }
  } 


  

}
